import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchWithAuth } from '../apiClient';

async function deleteScheduleRequest(originJobKey) {
  const r = await fetchWithAuth(`/scheduler/${originJobKey}/TestingGroup`, { method: 'DELETE' });
  if (r.status !== 204) throw new Error('Delete failed');
}

export function useDeleteSchedule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteScheduleRequest,
    onMutate: async (originJobKey) => {
      await qc.cancelQueries({ queryKey: ['schedules'] });
      const prev = qc.getQueryData(['schedules']);
      qc.setQueryData(['schedules'], (old = []) => old.filter(x => x.originJobKey !== originJobKey));
      return { prev };
    },
    onError: (_err, _vars, ctx) => {
      if (ctx?.prev) qc.setQueryData(['schedules'], ctx.prev);
    },
    onSettled: () => {
      qc.invalidateQueries({ queryKey: ['schedules'] });
    },
  });
}
